/*
 * Copyright (C) 2013 Minted Inc.
 *
 * All Rights Reserved
 *
 * CTAG:COMMUNITY:CHALLENGES
 */

(function (M, _, $, Backbone) {
  "use strict";

  M.View = M.View || {};
  M.View.Design = M.View.Design || {};

  /**
   * @class M.View.Design.Poll
   *
   */
  M.View.Design.Poll = Backbone.View.extend({
    tagName: 'div',
    className: 'communityDesignPoll',
    events: {
      'click .cancel': 'cancel',
      'click #startPoll': 'startPoll',
      'click .endPoll': 'endPoll'
    },
    options: {
      useMinimalOptionTemplate: false,
      hideHeader: false,
      hideResults: false,
      disableSelecting: false,
      // TODO: remove once we don't show designs by the current user
      shouldHidePollOwnerControls: false
    },

    template: M.Template.Design.Poll,

    errors: {
      startPollTitle: 'Error Starting Poll',
      genericMessage: 'We encountered an error. Please try again later.'
    },

    initialize: function() {
      this.$el = $(this.el);
      this.user = {
        id: +this.options.userId,
        vote: this.model.get('user_vote')
      };
      this.userIsDesigner = !this.options.shouldHidePollOwnerControls &&
          this.user.id &&
          this.user.id === +this.model.get('design').designer_user_id;

      $(window).on('beforeunload', _.bind(this.beforeUnload, this));
    },

    beforeUnload: function (e) {
      if (this.pollEdited && !this.pollStarted) {
        return 'You have not saved your changes to this poll.';
      }
    },

    render: function() {
      this.$el.html(this.template({poll: this}));
      this.renderOptions();
      return this;
    },

    /**
     * For every option in this.model.options, create a PollOption view and
     * render it, adding it into this.$('.options'). When the options are new,
     * manage which options are enabled for file uploading and which are
     * disabled.
     */
    renderOptions: function() {
      var optionsDiv = this.$('.options').empty();
      var optionViews = [];

      // Iterate through all the options and create a view for each one. Then
      // render that view and append the view's .el property to the optionsDiv.
      this.model.get('options').each(function (option, index) {
        var optionView = new M.View.Design.PollOption({
          model: option,
          userIsDesigner: this.userIsDesigner,
          renderData: {
            optionView: optionView,
            index: index,
            user: this.user,
            poll: this.model,
            designId: this.model.get('design').id
          },
          disabled: index !== 0,
          urlPaths: this.options.urlPaths,
          useMinimalTemplate: this.options.useMinimalOptionTemplate,
          hideResults: this.options.hideResults,
          disableSelecting: this.options.disableSelecting
        });
        optionViews.push(optionView);
        optionsDiv.append(optionView.render().el);
        // When this view has begun uploading a file, enable the next view
        // for file uploads.
        optionView.bind('fileuploadsubmit', _.bind(function() {
          this.pollEdited = true;
          var nextOptionView = optionViews[index + 1];
          if (nextOptionView) {
            nextOptionView.enable();
          }
        }, this));

        // If this file upload fails, disable the next view. If the view has
        // already started a file upload of its own, this will have no affect.
        optionView.bind('fileuploadfail', _.bind(function() {
          var nextOptionView = optionViews[index + 1];
          if (nextOptionView) {
            nextOptionView.disable();
          }
        }, this));

        optionView.bind('renderVoteView', _.bind(function (e) {
          var voteView = this.createVoteView(optionView);
          voteView.render();
        }, this));

        optionView.bind('castVote', _.bind(function (e) {
          var voteView = this.createVoteView(optionView);
          voteView.vote();
        }, this));
      }, this);

      this.optionViews = optionViews;
    },

    /**
     * Makes a vote view (the dialog that shows the votes in a larger size)
     * and returns it.
     *
     * @param {M.View.Design.PollOption} optionView The option view to start
     * with
     * @return {M.View.Design.PollVote} The vote view
     */
    createVoteView: function (optionView) {
      var voteView = new M.View.Design.PollVote({
        index: optionView.index,
        poll: this.model,
        optionViews: this.optionViews,
        user: this.user,
        // currently only pass-through to community comment model
        urlPaths: this.options.urlPaths,
        onVoteSuccessFcn: this.options.onVoteSuccessFcn
      });
      return voteView;
    },

    /**
     * Cancel's creation of the poll and reloads the page to the existing
     * design version.
     *
     * @param {event} e jQuery.Event
     */
    cancel: function (e) {
      e.preventDefault();
      window.location.reload();
    },

    /**
     * Creates the poll and reloads the page to the newly created poll.
     *
     * @param {event} e jQuery.Event
     */
    startPoll: function (e) {
      this.model.save().done(_.bind(function(data) {
        if (data.error) {
          this.showError(this.errors.startPollTitle, data.error);
        } else {
          this.pollStarted = true;
          location.assign('/design-rating/' + this.model.get('design').id);
        }
      }, this)).fail(_.bind(function () {
        this.showError(
          this.errors.startPollTitle, this.errors.genericMessage);
      }, this));
    },

    /**
     * Display an error to the user.
     *
     * @param {String} msg The error message to display.
     */
    showError: function (title, msg) {
      var el = $('<div>');
      el.html(msg);
      el.dialog({
        title: title
      });
    },

    /**
     * Shows the end poll dialog from which the user can end the poll.
     *
     * @param {event} e jQuery.Event
     */
    endPoll: function (e) {
      e.preventDefault();
      var pollEndView = new M.View.Design.PollEnd({
        model: this.model,
        optionViews: this.optionViews
      });
      pollEndView.render();
    }
  }, {
    /**
     * Fetches the poll (potentially pre-domready, so we don't waste that time)
     * and renders the view into the dom when ready.
     * @param {int} userId
     * @param {number} pollId The CommunityDesignPoll.id
     * @param {string|Object} selector The selector for the element
     * which will contain the view
     * @param {string|Object} context The context for the selector (optional)
     * @param {dictionary} urlPaths Dictionary of paths that is used by poll and
     * it's related objects
     * @param {fcn} onVoteSuccessFcn Function that happens after a vote is saved
     * @param {dictionary} additionalOptions Other flags that can be passed in
     */
    queryAndSetUpPoll: function (userId, pollId, selector, context, urlPaths,
        onVoteSuccessFcn, additionalOptions) {
      var model = new M.Model.Design.Poll({
        id: pollId,
        urlPaths: urlPaths
      });
      model.fetch();
      model.bind('change', _.once(function() {
        $(document).ready(function() {
          var viewOptions = {
            model: model,
            userId: userId,
            urlPaths: urlPaths,
            onVoteSuccessFcn: onVoteSuccessFcn
          };
          if (additionalOptions) {
            _.extend(viewOptions, additionalOptions);
          }
          var view = new M.View.Design.Poll(viewOptions);
          var el = (context ? $(selector, context) : $(selector));
          el.html(view.render().el);
        });
      }));
    }
  });

})(M, _, $, Backbone);
